import {InjectionToken} from '@angular/core'
import {UMEmbeddedService} from '@service/orders/ums/um.embedded.service'
import {UMService} from '@service/orders/ums/um.service'
import type {EmbeddedClientService} from '@service/embeddingService/embedded-client.service'

/**
 * Factory que resuelve la implementación adecuada de `UMService`.
 *
 * @description
 * Devuelve `UMEmbeddedService` cuando la app corre embebida y
 * `UMService` en modo standalone. `UMService` gestiona las unidades de
 * medida (UM) y las conversiones usadas al construir líneas de pedido.
 *
 * @param embeddedClientService Cliente que detecta si la app corre embebida.
 * @returns Instancia activa de `UMService`.
 */
export function providerUMFactory(embeddedClientService: EmbeddedClientService) {
  if (embeddedClientService.isEmbeddedFunction()) {
    return new UMEmbeddedService()
  }
  return new UMService()
}

/**
 * `InjectionToken` que referencia la instancia activa de `UMService`.
 *
 * @description
 * Registrado en `SERVICE_PROVIDERS` junto con {@link providerUMFactory}.
 * Los consumidores inyectan directamente `UMService` mediante el alias
 * `useExisting`.
 */
export const UMServiceToken = new InjectionToken<UMService>('UMService')
